import type { GridOptions } from "~/components/grid/AgGrid";

import GridRowCountStatusPanel from "~/components/grid/statusPanels/GridRowCountStatusPanel";
import GridSelectedRowCountStatusPanel from "~/components/grid/statusPanels/GridSelectedRowCountStatusPanel";

const SSRM_GRID_DEFAULTS = Object.freeze({
	blockLoadDebounceMillis: 150,
	cacheBlockSize: 100,
	maxBlocksInCache: 10,
	serverSideInitialRowCount: 30
} satisfies GridOptions);

export const SSRM_STATUS_BAR = Object.freeze({
	statusPanels: [
		{ align: "left", statusPanel: GridRowCountStatusPanel },
		{ align: "center", statusPanel: "agAggregationComponent" },
		{ align: "right", statusPanel: GridSelectedRowCountStatusPanel }
	]
} satisfies GridOptions["statusBar"]);

export default SSRM_GRID_DEFAULTS;
